function isAuctionEnded({ auction, blockNumber} ) {
  return Number(auction.endsAtBlock) < blockNumber;
}

function isHighestBidder({ auction, address }) {
  return auction.highestBidder === address;
}

function hasUnclaimedBalance({ unclaimedBids, auction }) {
  let amount = unclaimedBids[auction.auctionIndex];

  if (typeof amount === "undefined") {
    return false;
  } else {
    return Number(amount) !== 0;
  }
}

export default function filterMyAuctions(opts) {

  let myAuctions = {
    winning: [],
    losing: [],
    unclaimedLost: [],
    unclaimedWon: [],
  };

  opts.auctions.forEach(auction => {

    opts = { ...opts, auction };

    if (
      isAuctionEnded(opts) &&
      !isHighestBidder(opts) &&
      hasUnclaimedBalance(opts)
    ) { myAuctions.unclaimedLost.push(auction); }

    else if (
      !isAuctionEnded(opts) &&
      !isHighestBidder(opts) &&
      hasUnclaimedBalance(opts)
    ) { myAuctions.losing.push(auction); }

    else if (
      !isAuctionEnded(opts) &&
      isHighestBidder(opts)
    ) { myAuctions.winning.push(auction); }

    else if (
      isAuctionEnded(opts) &&
      isHighestBidder(opts) &&
      hasUnclaimedBalance(opts)
    ) { myAuctions.unclaimedWon.push(auction); }
  });

  return myAuctions;
}



// WEBPACK FOOTER //
// ./src/util/filterMyAuctions.js